import { Template, TemplateType } from '@marageti/z4-sdk/lib/templates/Template';

export const SMS_MESSAGE_PREFIX = 'Zicasso: ';
export const SMS_MAX_LENGTH = 640;

export type GroupedTemplate = Template & { group: string };

export const simplifyString = (string: string) => string.toLowerCase().replace(/[^a-z0-9]/g, '');

export const stripHtmlToPlainText = (html: string): string => {
  if (!html) return '';
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
};

export const getSmsLengthGuidance = (message: string) => {
  const count = message.length;
  const isOverMax = count > SMS_MAX_LENGTH;

  if (count <= SMS_MESSAGE_PREFIX.length || message.trim() === SMS_MESSAGE_PREFIX.trim()) {
    return {
      count,
      caption: 'Keep it short. Texts under 2 lines get the fastest replies.',
      isOverMax,
    };
  }

  if (count < 200) {
    return {
      count,
      caption: 'Good length, short texts get read on the lock screen.',
      isOverMax,
    };
  }

  if (count < 300) {
    return {
      count,
      caption: 'A bit long, texts under 2 lines get the fastest replies.',
      isOverMax,
    };
  }

  return {
    count,
    caption: 'Long messages often go unread. Move the details to the app.',
    isOverMax,
  };
};

export const isSmsMessageSendable = (message: string): boolean => {
  const trimmed = message.trim();
  if (!trimmed || trimmed === SMS_MESSAGE_PREFIX.trim()) return false;
  return message.length <= SMS_MAX_LENGTH;
};

export const capitalizeErrorMessage = (message: string): string => {
  if (!message) return message;
  return message.charAt(0).toUpperCase() + message.slice(1);
};

export const groupTemplates = (templates: Template[] | undefined): GroupedTemplate[] => {
  if (!templates) return [];

  const templateGroups = [
    { type: TemplateType.PersonalTemplate, label: '--- Personal ---' },
    { type: TemplateType.PartnerTemplate, label: '--- Team Templates ---' },
  ];

  return templateGroups.flatMap(({ type, label }) => templates
    .filter((template) => template.templateType === type)
    .sort((a, b) => a.title.localeCompare(b.title))
    .map((template) => ({
      ...template,
      group: label,
    })));
};
